import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { TwoColumnLayout } from '@factorialco/f0-react'
import {
  ContractsEmployeesJobCatalogTreeFragment,
  ResourceFieldDataFragment,
  TaskDetailAffecteeReferenceContractFragment,
  TaskDetailContractContextlessPoliciesFragment,
  TaskDetailCustomFieldsContextlessPoliciesFragment,
  TaskDetailJobCatalogContextlessPoliciesFragment,
  ValueDataFragment,
} from 'generated/resources/graphql'
import { TaskDetail } from 'modules/tasks/components/TaskElement/useTaskDetail'
import { TaskFile } from 'modules/tasks/hooks/useGetTaskFiles'
import { useMaterializedTaskItem } from 'modules/tasks/hooks/useMaterializedTaskItem'

import Content from './Content'
import Info from './Info'

interface Props {
  task: TaskDetail
  files: TaskFile[]
  loadingFiles: boolean
  canSeePersonalInfo: boolean
  canEditPersonalInfo: boolean
  canEmployeeManageAnyEmployeeFolder: boolean
  customResourceFieldsData: ResourceFieldDataFragment[]
  customValuesData: ValueDataFragment[]
  hasDevTimeTrackingWorkableDaysDefinition?: boolean
  hasTimeTrackingAnnualisationDailyValue?: boolean
  referenceContract?: TaskDetailAffecteeReferenceContractFragment | null
  jobCatalogContextlessPolicies: TaskDetailJobCatalogContextlessPoliciesFragment | undefined
  hasPayrollBundle: boolean
  contractContextlessPolicies: TaskDetailContractContextlessPoliciesFragment | undefined
  customFieldsContextlessPolicies: TaskDetailCustomFieldsContextlessPoliciesFragment | undefined
  jobCatalogTreeFeatureEnabled?: boolean
  jobCatalogTrees?: ContractsEmployeesJobCatalogTreeFragment[]
  hasProjectsTasksTimeTracking?: boolean
  canManageProjectTask?: boolean
}

const TaskDetails = ({
  task,
  files,
  loadingFiles,
  canSeePersonalInfo,
  canEditPersonalInfo,
  canEmployeeManageAnyEmployeeFolder,
  customResourceFieldsData,
  customValuesData,
  hasDevTimeTrackingWorkableDaysDefinition,
  hasTimeTrackingAnnualisationDailyValue,
  referenceContract,
  jobCatalogContextlessPolicies,
  hasPayrollBundle,
  contractContextlessPolicies,
  customFieldsContextlessPolicies,
  jobCatalogTreeFeatureEnabled,
  jobCatalogTrees,
  hasProjectsTasksTimeTracking,
  canManageProjectTask,
}: Props) => {
  const { workflowOwner, stepName, mandatory, loading } = useMaterializedTaskItem({
    taskId: task.id,
  })

  if (loading)
    return (
      <Box alignItems="center">
        <Spinner />
      </Box>
    )

  return (
    <TwoColumnLayout
      mainColumnPosition="left"
      sideContent={
        <Info
          stepName={stepName}
          mandatory={mandatory}
          task={task}
          hasProjectsTasksTimeTracking={hasProjectsTasksTimeTracking}
          canManageProjectTask={canManageProjectTask}
        />
      }
    >
      <Content
        files={files}
        loadingFiles={loadingFiles}
        task={task}
        owner={workflowOwner}
        canSeePersonalInfo={canSeePersonalInfo}
        canEditPersonalInfo={canEditPersonalInfo}
        canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
        referenceContract={referenceContract}
        customResourceFieldsData={customResourceFieldsData}
        customValuesData={customValuesData}
        hasDevTimeTrackingWorkableDaysDefinition={hasDevTimeTrackingWorkableDaysDefinition}
        hasTimeTrackingAnnualisationDailyValue={hasTimeTrackingAnnualisationDailyValue}
        jobCatalogContextlessPolicies={jobCatalogContextlessPolicies}
        hasPayrollBundle={hasPayrollBundle}
        contractContextlessPolicies={contractContextlessPolicies}
        customFieldsContextlessPolicies={customFieldsContextlessPolicies}
        jobCatalogTreeFeatureEnabled={jobCatalogTreeFeatureEnabled}
        jobCatalogTrees={jobCatalogTrees}
        hasProjectsTasksTimeTracking={hasProjectsTasksTimeTracking}
        canManageProjectTask={canManageProjectTask}
      />
    </TwoColumnLayout>
  )
}

export default TaskDetails
